import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { BulkUpdatePayload, Report } from 'types'

import { BannerRequestBody } from './types'

export const getDspCampaignFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/dsp_campaign_facts/aggregate/banner/',

        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getDspCampaignFacts)

export const getDspCampaignFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/dsp_campaign_facts/aggregate/banner/export/',
        params
    )

export const asyncUpdateDspFacts = (
    data: BulkUpdatePayload,
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch(
        '/api/dsp_campaign_facts/aggregate/banner/mutate/',
        data,
        {
            params: { ...params, metrics: null },
            headers: getCerebroHeaders(options.headers),
        }
    )
